<sbnb-content-header
  title="Marketing"
  novaContentId="direct-sites-marketing-edit"
  [saving]="saving"
  [recentlySaved]="recentlySaved"
  (saveClicked)="save()">
</sbnb-content-header>

<ng-template #loadingTemplate>
  <div class="flex justify-center">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</ng-template>

<section *ngIf="!loading else loadingTemplate" class="flex flex-col my-6">
  <form [formGroup]="marketingForm">
    <div class="flex flex-col space-y-4 border-b border-smoke pb-3">
      <div class="flex flex-col space-y-3">
        <div class="flex items-center space-x-3">
          <img src="/assets/iconography/google.svg" class="size-5" />
          <h3>Google</h3>
        </div>

        <span class="text-sm">
          Find the ID in your GA/GTM account in Accounts > Containers or in the installation instructions.
        </span>
      </div>
      <mat-radio-group
        class="flex flex-col max-w-lg"
        (ngModelChange)="googleTagTypeUpdated($event)"
        [(ngModel)]="googleTagType"
        [ngModelOptions]="{standalone: true}"
      >
        <mat-radio-button value="analytics">Google Analytics</mat-radio-button>
        <mat-radio-button value="tag-manager" class="flex items-start">
          <div fxLayout="column" fxLayoutGap="4px">
            <span>Google Tag Manager</span>
            <span class="text-sm text-night-lighter">
              You can still use Google Analytics through Google Tag Manager
            </span>
          </div>
        </mat-radio-button>
      </mat-radio-group>
      <mat-form-field *ngIf="googleTagType === 'analytics'" class="max-w-lg">
        <input
          id="ga-input"
          formControlName="gaId"
          matInput
          maxlength="20"
          placeholder="G-XXXXXXX"
        >
        <mat-error *ngIf="marketingForm.get('gaId').hasError('pattern')">
          Please enter a valid Google Analytics ID. (example: G-XXXXXXX)
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="googleTagType === 'tag-manager'" class="max-w-lg">
        <input
          id="gtm-input"
          formControlName="gtmId"
          matInput
          maxlength="20"
          placeholder="GTM-XXXXXXX"
        >
        <mat-error *ngIf="marketingForm.get('gtmId').hasError('pattern')">
          Please enter a valid Google Tag Manager ID. (example: GTM-XXXXXXX)
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-col space-y-4 mt-9">
      <div class="flex flex-col space-y-3">
        <div class="flex items-center space-x-3">
          <img src="/assets/iconography/meta.svg" class="size-5" />
          <h3>Meta Pixel</h3>
        </div>

        <span class="text-sm">
          Find the ID in your Meta Business Manager in Events Manager > Data Sources.
        </span>
      </div>
      <mat-form-field class="max-w-lg">
        <input
          id="meta-input"
          formControlName="metaId"
          matInput
          maxlength="20"
          placeholder="123456789012345"
        >
      </mat-form-field>
    </div>
  </form>
</section>
